import { Form, Select, Space, Spin, Typography } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useGetInterventionTemplate } from "@/entities/intervention-template";
import {
  INTERVENTION_TEMPLATES_FILTERS,
  useGetInterventionTemplates,
} from "@/entities/intervention-templates";
import { StateTag } from "@/modules/state-tag";
import { getSelectDropdownRender } from "@/ui/select-dropdown";

// TODO DEV-8551 `Option` and `OptGroup` are deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option, OptGroup } = Select;
const { Text } = Typography;

const VersionEdit = ({
  interventionTemplateId,
  onChange = void undefined,
  ...rest
}) => {
  const { t } = useTranslation();

  const { isLoading: isCurrentTemplateLoading, template: currentTemplate } =
    useGetInterventionTemplate(interventionTemplateId);

  // Get possible template revisions
  const { isLoading: isVariantsLoading, interventionTemplates } =
    useGetInterventionTemplates({
      params: {
        [INTERVENTION_TEMPLATES_FILTERS.ASSOCIABLE]: true,
        [INTERVENTION_TEMPLATES_FILTERS.REVISIONS_OF]: interventionTemplateId,
      },
    });

  const variants = interventionTemplates.filter(
    (variant) => variant.id !== interventionTemplateId
  );

  const isLoading = isCurrentTemplateLoading || isVariantsLoading;

  return (
    <>
      <Spin spinning={isLoading}>
        <Form.Item {...rest}>
          <Select
            data-testid="templateSelect"
            onChange={onChange}
            popupRender={getSelectDropdownRender({ multilineOptions: 2 })}
            styles={{ popup: { root: { minWidth: 500 } } }}
          >
            <OptGroup label={t("interventionTemplate:version.currentVersion")}>
              {currentTemplate?.state && (
                <Option key={currentTemplate.id} value={currentTemplate.id}>
                  <Space>
                    <StateTag
                      value={currentTemplate.state}
                      type="interventiontemplate"
                    />
                    <Text>{currentTemplate.name}</Text>
                    <Text>{`v${currentTemplate.version}`}</Text>
                  </Space>
                </Option>
              )}
            </OptGroup>
            <OptGroup label={t("interventionTemplate:version.revisionPlural")}>
              {variants.map((variant) => (
                <Option key={variant.id} value={variant.id}>
                  <StateTag value={variant.state} type="interventiontemplate" />
                  {`${variant.name} v${variant.version}`}
                </Option>
              ))}
            </OptGroup>
          </Select>
        </Form.Item>
      </Spin>
    </>
  );
};

VersionEdit.propTypes = {
  interventionTemplateId: PropTypes.number.isRequired,
  onChange: PropTypes.func,
};

export default VersionEdit;
